export class TacticsPlayer {
    constructor(name) {
        this.totalScore = 0;
        this.rounds = [];
        this.name = name;
        this.rounds = [
            new TacticsRound("20", 0),
            new TacticsRound("19", 0),
            new TacticsRound("18", 0),
            new TacticsRound("17", 0),
            new TacticsRound("16", 0),
            new TacticsRound("15", 0),
            new TacticsRound("25", 0)
        ];
    }
}
export class TacticsRound {
    constructor(segment, hits) {
        this.segment = segment;
        this.hits = hits;
    }
}
export class HistoryEvent {
    constructor(type, playerIndex, segment) {
        this.type = type;
        this.playerIndex = playerIndex;
        this.segment = segment;
    }
}
